import React, { useContext, useState } from 'react'
import { Badge, Button, FileInput, Flex, Grid, Group, Loader, Select, Textarea, TextInput } from '@mantine/core'
import { IconPhoto } from '@tabler/icons-react';
import { renderFile } from "../../../../utils/renderFile";
import AcademicContext from '../../../../contexts/AcademicContext';

const OTHER_TOPICS = [
   {
      label: "HABILIDADES CLÍNICAS",
      value: "HABILIDADES CLÍNICAS"
   },
   {
      label: "EDUCACIONAL",
      value: "EDUCACIONAL"
   },
   {
      label: "LIDERAZGO",
      value: "LIDERAZGO"
   }, {
      label: "BIENESTAR ANIMAL",
      value: "BIENESTAR ANIMAL"
   }, {
      label: "CASOS PRÁCTICOS",
      value: "CASOS PRÁCTICOS"
   },
   {
      label: "DROGAS Y TERAPIAS",
      value: "DROGAS Y TERAPIAS"
   }
]

export default function AcademicLibraryForm(props) {
   const { form, loading } = props;
   const { specialtiesOptions } = useContext(AcademicContext);
   const [newTagText, setNewTagText] = useState("")


   const removeTag = (tag) => {
      const filteredTags = form.values.tags?.filter(item => item !== tag)
      form.setFieldValue("tags", filteredTags)
   }

   const addTag = () => {
      const tags = form?.values?.tags || [];
      const exists = tags.length > 0 && tags.some(tag => newTagText.toLowerCase() === tag.toLowerCase());
      if (exists) return;

      const allTags = [...tags, newTagText];
      form.setFieldValue('tags', allTags);
   };



   return (
      <Grid
         style={{ width: "100%" }}
         justify="center"
         align="center"
      >
         <Grid.Col span={12}>
            <TextInput
               label="Título"
               name="title"
               {...form.getInputProps("title")}
            />
         </Grid.Col>
         <Grid.Col span={12}>
            <Textarea
               label="Descripción"
               name="description"
               {...form.getInputProps("description")}
               rows={3}
            />
         </Grid.Col>

         <Grid.Col span={12}>
            <Flex wrap='wrap' align='center' gap={10} justify='start'>
               {form?.values?.tags?.length > 0 && form?.values?.tags?.map((tag, idx) => {
                  const isSpecialty = specialtiesOptions.find(item => item.value === tag)?.label
                  if (isSpecialty) return (
                     <Badge
                        className='AcademicLibraryForm--tag-badge'
                        onClick={() => removeTag(tag)}
                        size='sm'
                        key={idx}
                     >
                        {specialtiesOptions.find(item => item.value === tag)?.label}
                     </Badge>
                  )
                  return <Badge
                     className='AcademicLibraryForm--tag-badge'
                     onClick={() => removeTag(tag)}
                     size='sm'
                     key={idx}
                  >
                     {tag}
                  </Badge>
               })}
            </Flex>
         </Grid.Col>


         <Grid.Col span={12}>

            <Group justify='start' align='end'>
               <Select
                  searchable
                  data={[
                     { group: "Especialidades:", items: specialtiesOptions },
                     { group: "Otros temas", items: OTHER_TOPICS }
                  ]}
                  name='tag'
                  label='Etiquetas'
                  onChange={(value) => { setNewTagText(value)}}
               />
               <Button
                  variant='outline'
                  disabled={!newTagText}
                  onClick={addTag}
               >
                  Agregar
               </Button>
            </Group>


         </Grid.Col>

         <Grid.Col span={12}>

            <TextInput
               name='lang'
               label='Idioma'
               {...form.getInputProps("lang")}
            />


         </Grid.Col>

         <Grid.Col span={{ base: 12, sm: 6 }}>
            <Select
               label="Tipo"
               name="type"
               {...form.getInputProps("type")}
               data={[
                  {
                     label: "Artículo",
                     value: "article"
                  },
                  {
                     label: "Video",
                     value: "video"
                  },
                  {
                     label: "Audio",
                     value: "audio"
                  },
                  {
                     label: "Ebook",
                     value: "ebook"
                  },
                  {
                     label: "Presentación",
                     value: "presentation"
                  },
                  {
                     label: "Link",
                     value: "link"
                  }
               ]}
            />
         </Grid.Col>

         <Grid.Col span={{ base: 12, sm: 6 }}>
            <Select
               label="Formato"
               name="format"
               data={['mp4', 'mp3', 'pdf', 'epub', 'pptx', 'html', 'link']}
               {...form.getInputProps("format")}
            />
         </Grid.Col>

         <Grid.Col span={12}>
            <TextInput
               label="URL"
               name="url"
               {...form.getInputProps("url")}
            />
         </Grid.Col>

         <Grid.Col span={12}>
            <FileInput
               {...form.getInputProps("image")}
               label="Imagen"
               w='100%'
               placeholder='Cargar imagen'
               leftSection={<IconPhoto size={30} />}
               disabled={loading}
               onChange={(file) => {
                  renderFile(file).then((_fileBase64) => {
                     form.setFieldValue("image", _fileBase64);
                  });
               }}
               accept='image/*'
            />
         </Grid.Col>

         <Grid.Col span={12}>
            <TextInput
               label="Autor & cita"
               name="author"
               {...form.getInputProps("author")}
            />
         </Grid.Col>

         <Grid.Col span={12}>
            <Button
               type='submit'
            >
               {loading ? <Loader /> : "Guardar contenido"}
            </Button>
         </Grid.Col>
      </Grid>
   )
}

